import React from 'react'
import ContentLoader from 'react-content-loader'

const SkeletonsWhatIfArticle = props => {
  return (
    <ContentLoader
      viewBox="0 0 100% 650"
      height={300}
      width={'100%'}
      {...props}
    >
      <rect x="0" y="0" rx="3" ry="3" width="20%" height="40" />
      <rect x="25%" y="0" rx="3" ry="3" width="35%" height="40" />
      <rect x="65%" y="0" rx="3" ry="3" width="40%" height="40" />
      <rect x="0" y="50" rx="3" ry="3" width="20%" height="40" />
      <rect x="25%" y="50" rx="3" ry="3" width="35%" height="40" />
      <rect x="65%" y="50" rx="3" ry="3" width="40%" height="40" />
      <rect x="0" y="100" rx="3" ry="3" width="20%" height="40" />
      <rect x="25%" y="100" rx="3" ry="3" width="35%" height="40" />
      <rect x="65%" y="100" rx="3" ry="3" width="40%" height="40" />

      <rect x="0" y="200" rx="3" ry="3" width="45%" height="40" />
      <rect x="50%" y="200" rx="3" ry="3" width="50%" height="40" />
      <rect x="0" y="250" rx="3" ry="3" width="45%" height="40" />
      <rect x="50%" y="250" rx="3" ry="3" width="50%" height="40" />
    </ContentLoader>
  )
}
export default SkeletonsWhatIfArticle
